import { gsap } from 'gsap'; // Also works with TweenL
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class CollageSection extends HTMLElement {
  constructor() {
    super();
    this.timeline = gsap.timeline();
    this.scrollTrigger = null;

    this._build();
  }

  onUnload() {
    if (this.timeline) this.timeline.kill();
    if (this.scrollTrigger) this.scrollTrigger.kill();
  }

  _build() {
    this._setupCollageAnimation();
  }

  _setupCollageAnimation() {
    var collage = this.querySelector('.collage');
    var collageInfo = this.querySelector('.collage-info');
    var collageCols = this.querySelectorAll('.collage__col');
    console.log(collage, collageInfo, collageCols);

    // Create a scroll trigger for animation
    this.scrollTrigger = ScrollTrigger.create({
      trigger: collage,
      pin: collageInfo,
      pinType: 'transform',
      scroller: document.body,
      scrub: true,
      toggleActions: 'play none reverse none',
      invalidateOnRefresh: true,
      start: function () {
        return 'top top';
      },
      end: function () {
        return 'bottom bottom';
      },
    });

    if (collageCols && collageCols.length) {
      var _this = this;
      // Iterate through collage columns and set scroll animations
      collageCols.forEach(function (col) {
        var depth = parseFloat(col.dataset.depth);
        _this.timeline.to(col, {
          yPercent: depth,
          duration: 0.3,
          scrollTrigger: {
            trigger: collage,
            start: 'top bottom',
            end: 'bottom top',
            scrub: true,
          },
        });
      });
    }
  }
}

customElements.define('collage-section', CollageSection);
